import { render, staticRenderFns } from "./checks_vip.vue?vue&type=template&id=00b5ec5b"
import script from "./checks_vip.vue?vue&type=script&lang=js"
export * from "./checks_vip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports